import { Box, Card, Typography } from '@mui/material';
import { lighten, styled } from '@mui/material/styles';

export const Wrapper = styled(Card)`
  background-color: ${(p) => p.theme.palette.background.paper};
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  border: 1px solid ${(p) => p.theme.palette.grey[300]};
  &.no-shadow {
    box-shadow: none;
  }
`;

export const Header = styled(Box)`
  padding: ${(p) => p.theme.spacing(1, 1)};
  border-bottom: 1px solid ${(p) => p.theme.palette.grey[300]};
  flex: 0;
`;

export const Title = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SubTitle = styled(Typography)``;

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: ${(p) => p.theme.spacing(1.5)};
  height: 100%;
  gap: ${(p) => p.theme.spacing(1)};
  position: relative;
  flex-grow: 0;

  > * {
    flex: none;
  }

  &.gradient {
    background: radial-gradient(
      circle,
      ${(p) => lighten(p.theme.palette.primary[500], 0.8)} 8%,
      transparent 48%
    );
  }
`;
